import { render, staticRenderFns } from "./settlementSetDatail.vue?vue&type=template&id=1a5e4607&scoped=true&"
import script from "./settlementSetDatail.vue?vue&type=script&lang=js&"
export * from "./settlementSetDatail.vue?vue&type=script&lang=js&"
import style0 from "./settlementSetDatail.vue?vue&type=style&index=0&id=1a5e4607&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a5e4607",
  null
  
)

export default component.exports